import { render } from "./RunButton.vue?vue&type=template&id=65badbf8&scoped=true&ts=true"
import script from "./RunButton.vue?vue&type=script&lang=ts"
export * from "./RunButton.vue?vue&type=script&lang=ts"

import "./RunButton.vue?vue&type=style&index=0&id=65badbf8&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65badbf8"]])

export default __exports__